import client from './api-client';

export const getConfiguracionForm92 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form92: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getConsultaCasos= async(query) => {
    try {
        
        const response = await client.get(`informe-profesional/casos-atender?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                consultaCasos: response.data.object,
                query:query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}